<template>
  <main class="contact-us">
    <WCBreadcrumb
      :crumbs="storeCrumbs"
      @selected="breadcrumbs[breadcrumbs.length - 1]"
      class="p-0 ml-n2"
    />
    <h1 tabindex="-1" ref="focusFirst" class="contact-header mb-4 pb-3 pl-3">
      {{ $t('contactUs') }}
    </h1>
    <div class="row no-gutters mb-4">
      <div ref="mapElement" class="contact-us contact-us__map col-lg-8 col-md-6"></div>
      <WCStoreInfo class="col-lg-4 col-md-6 pl-md-4 pt-md-0 pt-4" />
    </div>
    <WCContactUsForm class="mb-5" v-if="email && email.email" />
  </main>
</template>

<script>
import { getLocationEmail } from '@/utils';
import FocusMixin from '@/mixins/FocusMixin';
import MapService from '../../services/map.service';
import WCContactUsForm from './components/WCContactUsForm/WCContactUsForm.vue';
import WCStoreInfo from './components/WCStoreInfo/WCStoreInfo.vue';
import WCBreadcrumb from '../../components/WCBreadcrumb/WCBreadcrumb.vue';

export default {
  name: 'ContactUs',
  components: {
    WCContactUsForm,
    WCStoreInfo,
    WCBreadcrumb,
  },
  data() {
    return {
      map: null,
    };
  },
  mixins: [FocusMixin], // Mixin for main content focus via routing
  computed: {
    /**
     * To display crumbs data
     */
    storeCrumbs() {
      const breadcrumbs = this.$route.meta.breadcrumbs;
      return breadcrumbs && breadcrumbs.length ? breadcrumbs : [];
    },
    email() {
      return getLocationEmail(this.$configuration.store);
    },
  },
  async mounted() {
    const store = this.$configuration.store;
    if (store.latitude && store.longitude) {
      const mapService = new MapService();

      mapService.load().then(() => {
        const position = new google.maps.LatLng(store.latitude, store.longitude);
        const options = {
          zoom: 15,
          mapTypeControl: false,
          streetViewControl: false,
          fullscreenControl: false,
          gestureHandling: 'greedy',
          center: position,
        };
        this.map = new google.maps.Map(this.$refs.mapElement, options);

        // eslint-disable-next-line no-new
        new google.maps.Marker({
          map: this.map,
          title: store.name,
          position,
        });
      });
    }
  },
};
</script>

<style scoped lang="scss">
@import '~@/assets/styles/tools';
@import '~@/assets/styles/settings';

.contact-header {
  margin-left: -$container-gutter;
  margin-right: -$container-gutter;
  border-bottom: 3px solid var(--secondary, $secondary);
}
.contact-us__map {
  height: rem(400px);
  border: 1px solid var(--gray-500, $gray-500);
}

@include media-breakpoint-down(md) {
  .contact-us__map {
    height: rem(300px);
  }
}
</style>
